module.exports = __webpack_public_path__ + "img/shape.fcc1f3b8.png";